import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBriefcase, faUsers, faHardHat, faIdCard, faClock, faBook, 
  faClipboardList, faMoneyCheckAlt, faMoneyBillWave, faHandsHelping, 
  faImage, faEye, faStar, faQrcode, faUser, faLockOpen,
  faSadCry,
  faWallet,
  faSearch, faClipboardQuestion, faClockRotateLeft
} from '@fortawesome/free-solid-svg-icons';
import './JobsWorks.css';
// import bluehandsimage from '../../assets/gdashboard/BlueHands.webp';

function ModernTechJobsHome() {
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [searchQuery, setSearchQuery] = useState("");
  const [category, setCategory] = useState("Labour");
  const [city, setCity] = useState("Mumbai");

  const handleSearch = () => {
    // console.log("Search Query:", searchQuery);
    // console.log("Category:", category);
    // console.log(s"City:", city);
    // API Call for database fetching logic here
  };


  return (
    <MainLayout>
      <div className="min-h-full py-8 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 mt-12">
        <h2 className='text-3xl font-bold text-white text-center mb-6'>ModernTech Jobs</h2>
        <div className="min-h-[100vh] px-4">
          <div className="flex flex-col items-center mb-8 mt-16 border-2 border-yellow-200 rounded-md p-6">
            <div className="flex flex-row justify-center md:flex-row md:space-x-4 space-y-4 md:space-y-0 w-full">
              <label>
                <FontAwesomeIcon icon={faSearch} className='text-yellow-200 text-lg ml-4'/>
              </label>
              <input
                type="text"
                placeholder="Enter search keywords eg Prompt Engineer, Cybersecurity etc"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
              >
                <option value="Prompt Engineer/Writer">Prompt Engineer/Writer</option>
                <option value="AI Trainer">AI Trainer</option>
                <option value="Data Labeler">Data Labeler</option>
                <option value="AI Ethics Consultant">AI Ethics Consultant</option>
                <option value="Machine Learning Operations (MLOps) Engineer">Machine Learning Operations (MLOps) Engineer</option>
                <option value="AI Chatbot Developer">AI Chatbot Developer</option>
                <option value="Virtual Reality (VR)/Augmented Reality (AR) Developer">Virtual Reality (VR)/Augmented Reality (AR) Developer</option>
                <option value="AI Content Moderator">AI Content Moderator</option>
                <option value="Blockchain Developer">Blockchain Developer</option>
                <option value="AI-Powered Business Analyst">AI-Powered Business Analyst</option>
                <option value="Personal AI Assistant Manager">Personal AI Assistant Manager</option>
                <option value="AI-Enhanced Healthcare Specialist">AI-Enhanced Healthcare Specialist</option>
                <option value="Voice Interaction Designer">Voice Interaction Designer</option>
                <option value="Human-AI Interaction Specialist">Human-AI Interaction Specialist</option>
                <option value="Cryptocurrency Specialist">Cryptocurrency Specialist</option>
                <option value="Autonomous Vehicle Specialist">Autonomous Vehicle Specialist</option>
                <option value="AI-based Marketing Specialist">AI-based Marketing Specialist</option>
                <option value="Influencer Marketing Manager (AI-assisted)">Influencer Marketing Manager (AI-assisted)</option>
                <option value="AI Cybersecurity Analyst">AI Cybersecurity Analyst</option>
                <option value="Digital Twin Specialist">Digital Twin Specialist</option>
                <option value="IoT Solutions Architect">IoT Solutions Architect</option>
                <option value="Industrial IoT (IIoT) Engineer">Industrial IoT (IIoT) Engineer</option>
                <option value="Smart City Planner">Smart City Planner</option>
                <option value="Edge Computing Engineer">Edge Computing Engineer</option>
                <option value="Autonomous Robotics Engineer">Autonomous Robotics Engineer</option>
                <option value="Smart Agriculture Specialist">Smart Agriculture Specialist</option>
                <option value="AI-Powered Supply Chain Manager">AI-Powered Supply Chain Manager</option>
                <option value="Cloud IoT Architect">Cloud IoT Architect</option>
                <option value="Smart Wearables Developer">Smart Wearables Developer</option>
                <option value="Quantum Computing Specialist">Quantum Computing Specialist</option>
              </select>
              <select
                value={city}
                onChange={(e) => setCity(e.target.value)}
                className="border border-gray-300 rounded-md px-4 py-3 w-full md:w-auto focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                style={{ border: '1px solid #ccc', padding: '8px', height: '36px', minHeight: '40px' }}
                >
                <option value="Anywhere in India">Anywhere in India</option>
                <option value="Mumbai">Mumbai</option>
                <option value="Delhi">Delhi</option>
                <option value="Bangalore">Bangalore</option>
                <option value="Ahmedabad">Ahmedabad</option>
                <option value="Hyderabad">Hyderabad</option>
                <option value="Chennai">Chennai</option>
                <option value="Pune">Pune</option>
                <option value="Anywhere in World">Anywhere in World</option>
                <option value="London">London</option>
                <option value="Singapore">Singapore</option>
                <option value="Dubai">Dubai</option>
                <option value="Moscow">Moscow</option>
                <option value="Beijing">Beijing</option>
                <option value="Tokyo">Tokyo</option>
              </select>
            </div>
            <div>
              <button
                onClick={handleSearch}
                className="bg-blue-800 text-white px-6 py-2 w-40 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-800"
              >
                Search
              </button>
              <button
                onClick={handleSearch}
                className="bg-blue-800 text-white px-6 py-2 w-40 hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-800"
              >
                Instant
              </button>
            </div>
          </div>


          <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-250">
            <CardLink to="/bluehands-iamavailable" icon={faHandsHelping} text="I am Available" />
            <CardLink to="/myprofile-blueprofile" icon={faUser} text="My Modern Tech Profile" />
            <CardLink to="/contact-genious-myqr" icon={faQrcode} text="My QR Code" />
            <CardLink to="/contact-genious/blue" icon={faIdCard} text="My Secure Card" />
            <CardLink to={`/pub/blue/${userCode}`} icon={faLockOpen} text="My Public Card" />
            <CardNoLink to="" icon={faBook} text="My Work Diary" />
            <CardNoLink to="" icon={faUser} text="Write My Bio-Data" />
            {/* <CardLink to="/contact-genious-change-profile-image" icon={faImage} text="Profile Image" /> */}
            <CardNoLink to="" icon={faClipboardQuestion} text="My Shortlisted Jobs" />
            <CardNoLink to="" icon={faClockRotateLeft} text="Jobs I Applied" />
            <CardNoLink to="" icon={faQrcode} text="My Search Log" />
            <CardNoLink to="" icon={faEye} text="Who Searched Me" />
            <CardNoLink to="" icon={faWallet} text="Price List" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default ModernTechJobsHome;


